/**
 * This file was created to fix IE11 issues... may it die a fiery death.
 */

import "core-js/stable";
import "regenerator-runtime/runtime";